"use client";
import { jsx as s } from "react/jsx-runtime";
import { createContext as i, useState as u, useContext as a } from "react";
const e = i(void 0);
function f({ children: t, defaultIsOpen: o = !1 }) {
  const [n, r] = u(o);
  return /* @__PURE__ */ s(e.Provider, { value: { isOpen: n, setIsOpen: r }, children: t });
}
function l() {
  return a(e);
}
export {
  f as ModalProvider,
  l as useModal
};
